export default __webpack_public_path__ + "static/media/line_graph.cd68fdac.svg";